import * as React from "react";
import type { SVGProps } from "react";
const SvgInbox02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.4 13.2V18a2.4 2.4 0 0 0 2.4 2.4h14.4a2.4 2.4 0 0 0 2.4-2.4v-4.8m-19.2 0 3.016-8.043A2.4 2.4 0 0 1 7.663 3.6h8.674c1 0 1.896.62 2.247 1.557L21.6 13.2m-19.2 0h4.8l1.6 1.68h6.4l1.6-1.68h4.8"
    />
  </svg>
);
export default SvgInbox02;
